import { LatLng } from '../@types/location'
import { GetPlaceDetailRequest, GetPlaceDetailResult, Prediction } from '../@types/googleMaps'
import { sendErrorLog } from './logClient'
import { ErrorLogSource } from '../@types/errorLog'

const dummyDiv = document.createElement('div')

const failed = (status: google.maps.places.PlacesServiceStatus) =>
  status !== google.maps.places.PlacesServiceStatus.OK && status !== google.maps.places.PlacesServiceStatus.ZERO_RESULTS

const extractFromPlaceResult = (type: string, placeResult?: google.maps.places.PlaceResult | null) =>
  placeResult?.address_components
    ?.filter((addressComponent) => addressComponent.types.includes(type))
    .map((addressComponent) => addressComponent.long_name)
    .shift()

const getDescriptionWithoutCountry = (terms: google.maps.places.PredictionTerm[]) =>
  terms
    .slice(0, -1)
    .map((term) => term.value)
    .join(', ')

export const getPredictions = async (
  input: string,
  coordinates: LatLng,
  sessionToken: google.maps.places.AutocompleteSessionToken
): Promise<Prediction[]> => {
  return new Promise((resolve, reject) => {
    const autoCompleteService = new window.google.maps.places.AutocompleteService()
    const autoCompleteRequest: google.maps.places.AutocompletionRequest = {
      input: input,
      componentRestrictions: {
        country: 'de',
      },
      types: ['address'],
      bounds: new google.maps.LatLngBounds({
        lat: coordinates.latitude,
        lng: coordinates.longitude,
      }),
      sessionToken: sessionToken,
    }
    autoCompleteService.getPlacePredictions(autoCompleteRequest, (response, status) => {
      if (failed(status)) {
        const errorMessage = `Error while autocomplete, status: ${status}`
        sendErrorLog({
          message: errorMessage,
          source: ErrorLogSource.MAPS_PLACE_PREDICTIONS,
        })
        reject(errorMessage)
      }
      const predictions = response?.map((autoCompletePrediction) => ({
        description: getDescriptionWithoutCountry(autoCompletePrediction.terms),
        placeId: autoCompletePrediction.place_id,
      }))
      resolve(predictions || [])
    })
  })
}

export const getPlaceDetail = async (request: GetPlaceDetailRequest): Promise<GetPlaceDetailResult> => {
  return new Promise((resolve, reject) => {
    const placeService = new window.google.maps.places.PlacesService(dummyDiv)
    const placeDetailsRequest: google.maps.places.PlaceDetailsRequest = {
      placeId: request.placeId,
      sessionToken: request.sessionToken,
    }
    placeService.getDetails(placeDetailsRequest, (response, status) => {
      if (failed(status)) {
        const errorMessage = `Error while getting place details, status: ${status}`
        sendErrorLog({
          message: errorMessage,
          source: ErrorLogSource.MAPS_PLACE_DETAIL,
        })
        reject(errorMessage)
      }
      resolve({
        street: extractFromPlaceResult('route', response),
        houseNumber: extractFromPlaceResult('street_number', response),
      })
    })
  })
}
